import React from 'react';
import { detailsPropTypes } from './DetailsPropTypes';
import * as styles from './Details.module.scss';
const Details = ({
  category,
  date,
  isLarge
}) => /*#__PURE__*/React.createElement("div", {
  className: `${styles.root} ${!isLarge ? styles.rootSmall : ''}`
}, (category === null || category === void 0 ? void 0 : category.label) && (category === null || category === void 0 ? void 0 : category.href) && /*#__PURE__*/React.createElement("a", {
  href: category.href,
  className: styles.rootCategory
}, category.label), date && /*#__PURE__*/React.createElement("time", {
  className: styles.rootDate,
  dateTime: date.iso
}, /*#__PURE__*/React.createElement("span", {
  className: styles.rootDateHidden
}, date.label), date.string));
export default Details;